import { render, staticRenderFns } from "./dataVtex2.vue?vue&type=template&id=13c15eab&scoped=true"
import script from "./dataVtex2.vue?vue&type=script&lang=js"
export * from "./dataVtex2.vue?vue&type=script&lang=js"
import style0 from "./dataVtex2.vue?vue&type=style&index=0&id=13c15eab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c15eab",
  null
  
)

export default component.exports